import React from "react";
import {ColumnGroup} from "primereact/columngroup";
import {Row} from "primereact/row";
import {Column} from "primereact/column";
import GuaranteeForChange from "./GuaranteeForChangeView";
import {ControlPanelService} from "../../service/controlPanel/ControlPanelService";
import {
    amount,
    capacityMultipliedOneHundred,
    numberWithCommaEmptyValue,
    price,
    rateMultipliedByOneHundred
} from "../../utils/formatters/Numbers";
import NumberFormat from "react-number-format";
import {withoutComma} from "../../utils/calculate/Amount";
import {Growl} from "primereact/growl";


export default class GuaranteeForChangeContainer extends React.Component {
    constructor(props) {
        super(props);

        this.controlPanelService = new ControlPanelService();
        this.getGuarantee = this.getGuarantee.bind(this);
        this.calculateTotals = this.calculateTotals.bind(this);
        this.numberEditor = this.numberEditor.bind(this);
        this.onEditorValueChange = this.onEditorValueChange.bind(this);
        this.enableSuggest = this.enableSuggest.bind(this);
        this.setLoanAmount = this.setLoanAmount.bind(this);
        this.setMaturity = this.setMaturity.bind(this);

        this.disableStyleInstrument = this.disableStyleInstrument.bind(this);
        this.disableStyleInstrumentTemplate = this.disableStyleInstrumentTemplate.bind(this);
        this.disableStyleInstrumentAmountTemplate = this.disableStyleInstrumentAmountTemplate.bind(this);
        this.disableStyleInstrumentPriceTemplate = this.disableStyleInstrumentPriceTemplate.bind(this);
        this.disableStyleInstrumentNumberTemplate = this.disableStyleInstrumentNumberTemplate.bind(this);
        this.disableStyleInstrumentRateTemplate = this.disableStyleInstrumentRateTemplate.bind(this);
        this.disableStyleInstrumentCapacityTemplate = this.disableStyleInstrumentCapacityTemplate.bind(this);

        if (props.updateGuaranteeTotal) {
            this.updateGuaranteeTotal = props.updateGuaranteeTotal;
        }

        this.state = {
            loanId: props.loanId,
            loanType: props.loanType,
            readOnly: props.readOnly === undefined ? false : props.readOnly,
            loanAmount: props.loanAmount,
            guaranteeList: [],
            guaranteeAmountTotal: 0,
            marketAmountTotal: 0,
            maturity: 0,
            isPrecio24Hrs: props.isPrecio24Hrs ? props.isPrecio24Hrs : false,
        };


    }

    enableSuggest() {
        this.setState({
            readOnly: false,
        });
    }

    setLoanAmount(loanAmount) {
        this.setState({
            loanAmount: loanAmount,
        })
    }

    setMaturity(maturity) {
        this.setState({
            maturity: maturity,
        })
    }

    calculateSuggested() {
        let guaranteeList = this.state.guaranteeList;

        guaranteeList.map((item) => {

            let prize = this.state.isPrecio24Hrs ? item.precioDescontado : item.precioValDescontado;

            item.suggested = Math.floor((this.state.guaranteeAmountTotal - this.state.loanAmount) / prize);
            if (item.suggested < 0 || item.titulos - this.getZeroNumberNewTitles(item.newTitles) === 0) {
                item.suggested = 0;
            } else {
                if (item.suggested > (item.titulos - this.getZeroNumberNewTitles(item.newTitles))) {
                    item.suggested = item.titulos
                }
            }
            return '';
        });

        this.setState({
            guaranteeList: guaranteeList,
        });
    }

    getZeroNumberNewTitles(newTitles) {
        if (newTitles === undefined || newTitles === '') {
            return 0;
        } else {
            return newTitles;
        }
    }

    calculateAmount(row) {
        let prizeDiscount = this.state.isPrecio24Hrs ? row.precioDescontado : row.precioValDescontado;
        let prize = this.state.isPrecio24Hrs ? row.precioMercado : row.precioVal;

        row.guaranteeAmount = (row.titulos - this.getZeroNumberNewTitles(row.newTitles)) * prizeDiscount;
        row.marketAmount = (row.titulos - this.getZeroNumberNewTitles(row.newTitles)) * prize;

        return row;
    }


    calculateTotals(response) {
        let guaranteeAmountTotal = 0;
        let marketAmountTotal = 0;

        response.map((item) => {
            if (item.editable === "1") {
                item.newTitles = item.titulos;
            }

            item = this.calculateAmount(item);

            guaranteeAmountTotal += item.guaranteeAmount;
            marketAmountTotal += item.marketAmount;
            return '';
        });

        this.setState({
            guaranteeAmountTotal: guaranteeAmountTotal,
            marketAmountTotal: marketAmountTotal,
        })

        if (this.updateGuaranteeTotal) {
            this.updateGuaranteeTotal(guaranteeAmountTotal, marketAmountTotal);
        }
    }

    getGuarantee() {
        return this.controlPanelService.getGuaranteeLoanForChange(this.state.loanId, this.state.maturity)
            .then(response => {
                this.setState({
                    guaranteeList: response,
                });
                this.calculateTotals(response);
                this.calculateSuggested();
                this.props.loading(false);
            });
    }

    onEditorValueChange(props, value) {
        let guarantee = [...props.value];

        let valueWithoutComma = withoutComma(value);

        if (valueWithoutComma > guarantee[props.rowIndex].titulos) {
            valueWithoutComma = guarantee[props.rowIndex].titulos;
        }

        guarantee[props.rowIndex][props.field] = valueWithoutComma === 0 ? '' : valueWithoutComma;
        this.setState({guaranteeList: guarantee});

        this.calculateTotals(guarantee);
    }

    numberEditor(props, field) {
        return <NumberFormat
            className={"p-inputtext p-component"}
            disabled={props.rowData.editable === "1"}
            value={props.rowData.newTitles}
            thousandSeparator={true}
            allowNegative={false}
            allowEmptyFormatting={true}
            onChange={(e) => this.onEditorValueChange(props, e.target.value)}
            onBlur={(e) => this.calculateSuggested()}
        />
    }

    disableStyleInstrument(rowData, value) {
        let isDisabled = rowData.editable === "1";

        if (isDisabled) {
            return <span style={{color: 'lightgray'}}>{value}</span>;
        } else {
            return <span>{value}</span>;
        }
    }

    disableStyleInstrumentTemplate(rowData, column) {
        return this.disableStyleInstrument(rowData, rowData[column.field]);
    }

    disableStyleInstrumentAmountTemplate(rowData, column) {
        return this.disableStyleInstrument(rowData, amount(rowData[column.field], "right"));
    }

    disableStyleInstrumentPriceTemplate(rowData, column) {
        return this.disableStyleInstrument(rowData, price(rowData[column.field], "right"));
    }

    disableStyleInstrumentNumberTemplate(rowData, column) {
        return this.disableStyleInstrument(rowData, numberWithCommaEmptyValue(rowData[column.field], "right"));
    }

    disableStyleInstrumentRateTemplate(rowData, column) {
        return this.disableStyleInstrument(rowData, rateMultipliedByOneHundred(rowData[column.field], "right"));
    }

    disableStyleInstrumentCapacityTemplate(rowData, column) {
        return this.disableStyleInstrument(rowData, capacityMultipliedOneHundred(rowData[column.field], "right"));
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        let footerColumnGroup =
            <ColumnGroup>
                <Row>
                    <Column footer="Totales:" colSpan={this.state.readOnly ? 4 : 7} style={{textAlign: 'right'}}/>
                    <Column footer={amount(this.state.guaranteeAmountTotal, 'right')}/>
                    <Column footer={amount(this.state.marketAmountTotal, 'right')}/>
                </Row>
            </ColumnGroup>;


        return <GuaranteeForChange
            disableStyleInstrumentTemplate={this.disableStyleInstrumentTemplate}
            disableStyleInstrumentAmountTemplate={this.disableStyleInstrumentAmountTemplate}
            disableStyleInstrumentPriceTemplate={this.disableStyleInstrumentPriceTemplate}
            disableStyleInstrumentNumberTemplate={this.disableStyleInstrumentNumberTemplate}
            disableStyleInstrumentRateTemplate={this.disableStyleInstrumentRateTemplate}
            disableStyleInstrumentCapacityTemplate={this.disableStyleInstrumentCapacityTemplate}
            guaranteeList={this.state.guaranteeList}
            footerColumnGroup={footerColumnGroup}
            numberEditor={this.numberEditor}
            readOnly={this.state.readOnly}
            isPrecio24Hrs={this.state.isPrecio24Hrs}
            messagesGrowl={messagesGrowl}
        />
    }
};